import { render, staticRenderFns } from "./CustomCombinationToPolicyButton.vue?vue&type=template&id=218b1446&"
import script from "./CustomCombinationToPolicyButton.vue?vue&type=script&lang=js&"
export * from "./CustomCombinationToPolicyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports